import { render, staticRenderFns } from "./create-layout.vue?vue&type=template&id=33015580&scoped=true&"
import script from "./create-layout.vue?vue&type=script&lang=js&"
export * from "./create-layout.vue?vue&type=script&lang=js&"
import style0 from "./create-layout.vue?vue&type=style&index=0&id=33015580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33015580",
  null
  
)

export default component.exports